import { useQuery } from '@hooks/reactQuery';

import { getChangeMonitoringStatuses } from '@api/manageNetworkElementConfigurations';

import { nameTitleToOptionFormatted } from '@utils/formatter';

import { IIsActive } from '@interfaces/common/common';
import { IWithNetworkElementId } from '@interfaces/networkElementConfigurations/dto/networkElementConfigurationsDTO';
import { TSelectOptionType } from '@components/common/Select/Select.types';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { NETWORK_ELEMENT_CHANGE_MONITORING_STATUSES } from '@constants/queryKeys';

interface IUseQueryChangeMonitoringStatusesReturn {
	isLoadingChangeMonitoringStatuses: boolean;
	changeMonitoringStatuses: TSelectOptionType<string>[];
}

export const useQueryChangeMonitoringStatuses = (
	params: IWithNetworkElementId & IIsActive,
): IUseQueryChangeMonitoringStatusesReturn => {
	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [NETWORK_ELEMENT_CHANGE_MONITORING_STATUSES, params],
		queryFn: () => getChangeMonitoringStatuses(params),
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		enabled: [!!params.networkElementId],
		select: nameTitleToOptionFormatted,
		...refetchOptions,
	});

	return {
		isLoadingChangeMonitoringStatuses: isInitialLoading,
		changeMonitoringStatuses: data || [],
	};
};
